<template>
  <div id="gym">
    <v-card class="mb-3">
      <v-card-title>
        {{ title }}
        <v-spacer />

        <v-btn-toggle
          v-model="viewMode"
          mandatory
          color="primary"
          class="mr-3"
        >
          <v-btn value="map" small>
            <v-icon small>mdi-map</v-icon>
          </v-btn>
          <v-btn value="list" small>
            <v-icon small>mdi-format-list-bulleted</v-icon>
          </v-btn>
        </v-btn-toggle>

        <v-btn
          color="success"
          @click="add()"
          v-if="userCanCreate"
        >Добавить</v-btn>
      </v-card-title>
    </v-card>

    <v-card v-if="viewMode === 'map'" :loading="loading">
      <v-container
        fluid
        class="yandex-map"
      >
        <yandex-map
          :coords="mapCoords"
          :zoom="10"
          :controls="mapControls"
          :options="mapOptions"
        >
          <ymap-marker
            v-for="gym in gymsWithPoint"
            :key="gym.id"
            :marker-id="gym.id"
            :coords="[gym.point.lat, gym.point.lon]"
            cluster-name="1"
            @click="edit(gym)"
          />
        </yandex-map>
      </v-container>
    </v-card>

    <v-card v-else>
      <v-data-table
        :headers="headers"
        :items="points"
        :loading="loading"
        loading-text="Загрузка..."
        no-data-text="Залы не найдены."
        class="elevation-0"
      >
        <template v-slot:item.point="{ item }">
          <span v-if="item.point">
            {{ item.point.lat }}, {{ item.point.lon }}
          </span>
          <span v-else>Не указана</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon small @click.stop="edit(item)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>

</template>

<script>
import { EntityIndex } from "@/mixins";
import { yandexMap, ymapMarker } from "vue-yandex-maps";
import Config from "@/config";

export default {
  name: "index",

  components: {
    yandexMap,
    ymapMarker
  },

  metaInfo() {
    return {
      title: this.title
    };
  },

  mixins: [EntityIndex],

  data: () => ({
    ...Config.map,
    title: "Залы",
    loading: false,
    viewMode: "map",
    points: [],
    policyKey: "gym_policy",
    headers: [
      { text: "ID", value: "id", width: 90 },
      { text: "Название", value: "title" },
      { text: "Адрес", value: "address" },
      { text: "Координаты", value: "point", sortable: false },
      { text: "", value: "actions", sortable: false, align: "end", width: 72 }
    ]
  }),

  mounted() {
    this.fetch();
  },

  computed: {
    gymsWithPoint() {
      return this.points.filter((gym) => gym.point && gym.point.lat && gym.point.lon);
    }
  },

  methods: {
    async fetch() {
      this.loading = true;

      const result = await this.$api.gym.gyms();

      if (result.data.data.gyms) {
        this.points = result.data.data.gyms;
      }

      this.loading = false;
    },

    add() {
      this.$router.push({ name: "GymEdit", params: { id: 0 } });
    },

    edit(item) {
      this.$router.push({ name: "GymEdit", params: { id: item.id } });
    }
  }
};
</script>


<style lang="scss" scoped>
.yandex-map {
  height: 600px;

  .ymap-container {
    height: 100%;
  }
}
</style>
